export const APISpin = {
  ENABLE_USER: `api/mobile/v1/spin/enable-user`,
};
